// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"SignIn_overlayWrapper__xxh9P","mainInputContainer":"SignIn_mainInputContainer__WqhHa","resultContainer":"SignIn_resultContainer__yc4q5"};